<template>
    <button v-shortkey="['meta', 's']" @shortkey="$emit('save')" @click="$emit('save')" :disabled="formStatus=='saving'" :class="{'button--saved': formStatus=='saved', 'button--saving': formStatus=='saving'}" class="button button--article">
        <span v-if="formStatus==null">{{$t('Save')}} {{$t(name)}}</span>
        <span v-if="formStatus=='saving'"><i class="material-icons">sync</i> <span v-t="'Saving'"></span></span>
        <span v-if="formStatus=='saved'"><i class="material-icons">check</i> <span v-t="'Saved'"></span></span>
    </button>
</template>

<script>
    export default {
        props: ['name', 'status'],
        data () {
            return {
                formStatus: null
            }
        },
        watch: {
            status (val) {
                if (val === null){
                    this.formStatus = null
                }else{
                    if (!val){
                        this.formStatus = 'saved'
                        var self = this
                        setTimeout(function(){
                            self.formStatus = null
                        }, 1500)
                    }else{
                        this.formStatus = 'saving'
                    }
                }
            }
        }
    }
</script>